import styled from 'styled-components';
import boxShadow from '../../configs/boxShadow';
import color from '../../configs/color';

const Wrapper = styled.div`
  position: relative;
  .component_action_menu {
    cursor: pointer;
    border-radius: 12px;
    padding: 2px 8px;
    font-size: 16px;
    font-weight: 600;
    color: ${color.black2};
    &.ghost {
      border-radius: unset;
      padding: 0;
      font-size: unset;
      font-weight: unset;
      color: unset;
    }
  }
  .component_action_menu_items {
    min-width: ${(props) => {
      return props.minWidth ? `${props.minWidth}px` : '177px';
    }};
  }
  .component_action_menu_items {
    position: absolute;
    padding: 8px 0;
    border: 1px solid ${color.grey2};
    box-shadow: ${boxShadow.normal};
    border-radius: 8px;
    background-color: white;
    right: 0;
    z-index: 10;
  }

  .component_action_menu_element {
    padding: ${(props) => {
      return props.padding ? props.padding : '12px 18px';
    }};
    .ant-input {
      width: 100%;
      /* margin: 10px 0; */
      padding: 12px 16px;
      border-radius: 12px;
      margin-right: 16px;
      border-color: ${color.grey1};
      height: 44px;
      :focus {
        border-color: ${color.green5};
      }
    }
  }
`;

export default Wrapper;

export const MenuItem = styled.div`
  padding: 12px 18px;
  display: flex;
  align-items: center;
  color: ${color.black2};
  font-size: 16px;
  cursor: pointer;
  border-bottom: 1px solid ${color.grey2};
  &:hover {
    background-color: ${color.grey4};
  }
  &.danger {
    color: ${color.red1};
    svg {
      color: ${color.red1};
    }
  }
  &.success {
    color: ${color.green1};
    svg {
      color: ${color.green1};
    }
  }

  &.last {
    border-bottom: unset;
  }

  .component_action_menu_icon {
    margin-right: 12px;
  }
`;
